<script setup lang="ts">
interface IconXmarkAltProps {
  color?: string
}
defineProps({
  color: null
})
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M6 18L18 6"
      :stroke="color || '#322A26'"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M18 18L6 6"
      :stroke="color || '#322A26'"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
</template>
